import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Table } from '@sorare/core/src/atoms/layout/Table';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import {
  laptopAndAbove,
  mobileAndAbove,
} from '@sorare/core/src/style/mediaQuery';

export const Wrapper = styled(Vertical).attrs({ gap: 2 })``;

export enum Areas {
  logo = 'logo',
  name = 'name',
  rewards = 'rewards',
  badge = 'badge',
  progress = 'progress',
  rewardsAndParticipants = 'rewardsAndParticipants',
  participants = 'participants',
  cta = 'cta',
}

export const TableStyled = styled(Table)`
  --columns: var(--triple-unit) minmax(0, max-content) 1fr;
  --areas: '${Areas.logo} ${Areas.name} ${Areas.participants}'
    '. ${Areas.rewards} ${Areas.cta}';

  @media ${mobileAndAbove} {
    --columns: var(--quadruple-unit) minmax(0, max-content) 1fr;
    --areas: '${Areas.logo} ${Areas.name} ${Areas.participants}'
      '. ${Areas.rewards} ${Areas.cta}';
  }
  @media ${laptopAndAbove} {
    --columns: calc(5 * var(--unit)) 2.5fr 0.5fr 2.5fr 0.5fr 1fr;
    --areas: '${Areas.logo} ${Areas.name} ${Areas.badge} ${Areas.rewards} ${Areas.participants} ${Areas.cta}';
  }
`;

export const TooltipWrapper = styled.div`
  display: none;
  @media ${laptopAndAbove} {
    display: block;
    color: var(--c-nd-600);
  }
`;

export const Grey = styled.span`
  display: flex;
  align-items: center;
  color: var(--c-nd-600);
`;

export const NumberWithUnit = styled(Horizontal).attrs({ gap: 0.5 })`
  font: var(--t-label-s);
  @media ${laptopAndAbove} {
    font: var(--t-body-s);
  }
`;

export const StyledLink = styled(Link)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &,
  &:hover,
  &:focus {
    color: inherit;
  }
`;

export const LeaderboardName = styled(HeadlineS).attrs({ as: 'h5' })`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
